import * as React from "react";
const SvgLightEnable = (props) => /* @__PURE__ */ React.createElement("svg", { id: "b", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 53 53", height: "1em", ...props }, /* @__PURE__ */ React.createElement("path", { id: "c", d: "M49.23,26.44h2.52M42.93,10.08l2.52-2.52M26.57,3.78V1.26M10.21,10.08l-2.52-2.52M3.91,26.44H1.4M21.54,51.61h10.07M39.16,26.44c0-6.95-5.64-12.59-12.59-12.58-6.95,0-12.59,5.64-12.58,12.59,0,5,2.97,9.53,7.55,11.53v6.08h10.07v-6.08c4.59-2,7.55-6.53,7.55-11.54", style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2.5px"
} }));
export default SvgLightEnable;
